export default __webpack_public_path__ + "static/media/LO_logo.81f72619.jpg";